export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14885.c5850c8c.jpg";